import { render, staticRenderFns } from "./voteOverviewReport.vue?vue&type=template&id=f3680cf4&scoped=true&"
import script from "./voteOverviewReport.vue?vue&type=script&lang=ts&"
export * from "./voteOverviewReport.vue?vue&type=script&lang=ts&"
import style0 from "./voteOverviewReport.vue?vue&type=style&index=0&id=f3680cf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3680cf4",
  null
  
)

export default component.exports